







































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Transporteur, Fournisseur} from '@/models';

import CrudTransporteurEdit from '@/components/Crud/Transporteur/Edit.vue';

@Component({
	components: {
		CrudTransporteurEdit,
	}
})
export default class CrudTransporteurEditDialog extends Vue {
	@InOut({ type: Transporteur  , isVModel: true }) private value!: Transporteur;
	@Prop({ type: Fournisseur, default: null}) fournisseur: Fournisseur;

	@Emit()
	private onSubmit(transporteur: Transporteur) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
